import React from "react";
import FInput from "../FInput/FInput";
import Fbutton from "../Finputs/FButton/Fbutton";
import { useFBillContainer } from "./hooks/useFBillContainer";
import styles from "./style/FBillContainer.module.scss";
import Floading from "../../components/Floading/Floading";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";

const FBillContainer = ({
  btnTitle = "",
  total = "",
  originCurrencyId = "484",
  btnOnChange,
  products = [],
  component = null,
  disabledButton = true,
}) => {
  const { formatWithCurrencyISO } = useCurrencyFormat();

  return (
    <>
      <div className=" border-0 w-full bg-[#f0f0f0] grid grid-cols-2 px-10 rounded-3xl">
        {products.length > 0
          ? (<>
            {[products[0]].map((product, index) => (
              <>
                <div className="col-span-1 border-0 text-[3.5vw] xss:text-[16px] smm:text-[16px] font-regular pt-2">
                  {product.displayName}
                </div>
                <div className="col-span-1 border-0 text-right text-[4vw] xss:text-[16px] smm:text-[24px] font-bold pt-2">
                  {!product.request ? "$0.00 USD" : formatWithCurrencyISO(product.request.amount, originCurrencyId)}
                </div>

                {product.commissions.map((commission, index) => (
                  <>
                    <div className="col-span-1 mt-5 border-0 text-[3.5vw] xss:text-[16px] smm:text-[16px] font-regular pt-2">
                      {(commission.code == "FEE_FIXED_AMOUNT") ? "Comisión" : ""}
                    </div>
                    <div className="col-span-1 mt-5 border-0 text-right text-[4vw] xss:text-[16px] smm:text-[24px] font-bold pt-2">
                      {formatWithCurrencyISO(commission.value, originCurrencyId)}
                    </div>
                  </>
                ))}

                {product.taxes.map((taxe, index) => (
                  <>
                    <div className="col-span-1 mt-5 border-0 text-[vw] xss:text-[16px] smm:text-[16px] font-regular pt-2">
                      {(taxe.code == "COMSUMPTION_TAX") ? "IVA" : ""}

                    </div>
                    <div className="col-span-1 mt-5 border-0 text-right text-[4vw] xss:text-[16px] smm:text-[24px] font-bold pt-2">
                      {formatWithCurrencyISO(taxe.value, originCurrencyId)}
                    </div>
                  </>
                ))}

              </>
            ))}

            <div className="border-[1px] border-black border-dashed col-span-2 mt-5"></div>
            <div className="col-span-1 border-0 text-[4vw] xss:text-[16px] smm:text-[24px] font-regular my-10">
              Total
            </div>
            <div className="col-span-1 border-0 text-right text-[4vw] xss:text-[16px] smm:text-[24px] font-bold text-primary my-10 ">
              {!total ? "$0.00 USD" : total}
            </div>
          </>)
          : (<Floading open={true}></Floading>)}
      </div>

      <Fbutton
        value={btnTitle}
        disabled={disabledButton}
        onClick={btnOnChange}
      />
    </>
  );
};

export default FBillContainer;
